module.exports = __webpack_public_path__ + "img/inform_img_event.2ec00412.png";